import { FormGroup } from '@angular/forms';
import dayjs from 'dayjs';
import diff from 'microdiff';

export function validateAllFormControls(form: FormGroup) {
  Object.keys(form.controls).forEach(field => {
    const control = form.get(field);
    control?.markAsTouched({ onlySelf: true });
    control?.markAsDirty({ onlySelf: true });
  });
}

export function getDiffAsText(oldValues: object, newValues: object) {
  let count = 0;
  let text = '';
  const diffs = diff(oldValues, newValues);
  diffs.forEach(d => {
    if (count > 0) {
      text = text + '\n';
    }
    text = text + d.path.join('.') + ': ';
    if (d.type === 'CREATE') {
      text = text + '=> ' + d.value;
    }
    if (d.type === 'REMOVE') {
      text = text + d.oldValue + ' =>';
    }
    if (d.type === 'CHANGE') {
      text = text + d.oldValue + ' => ' + d.value;
    }
    count++;
  });
  return text;
}

export function getQueryString(form: FormGroup) {
  const values = form.value;
  let qs = '';
  let count = 0;
  Object.keys(values).forEach(field => {
    if (count == 0) {
      qs += '?';
    }
    if (count > 0) {
      qs += '&';
    }
    qs += `${field}=${values[field]}`;
    count++;
  });
  return qs;
}

export function handleBooleans(values: Record<string, any>) {
  const returnObject: Record<string, any> = {};
  Object.keys(values).forEach(field => {
    let value = values[field];
    if (value === 'true') {
      value = true;
    }
    if (value === 'false') {
      value = false;
    }
    returnObject[field] = value;
  });
  return returnObject;
}

export function toDayjs(dateString?: string) {
  if (!dateString) return undefined;
  return dayjs(dateString).toDate();
}

export function cloneObject(obj?: object) {
  if (!obj) return obj;
  return JSON.parse(JSON.stringify(obj));
}

export function compareObjects(
  obj1: Record<string, any>,
  obj2: Record<string, any>
) {
  for (const [key, value] of Object.entries(obj1)) {
    if (value instanceof Object) {
      compareObjects(value, obj2[key]);
    } else {
      obj1[key] = { oldValue: value };
      if (obj2[key]) {
        obj1[key].newValue = obj2[key];
        obj1[key].diff = obj1[key].oldValue !== obj1[key].newValue;
      }
    }
  }
}

export function isObject(item:any) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target:any, ...sources:any[]) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}
